<template>
  <Modal
    v-if="shown"
    :title="titleText"
    @close="show(false)"
    :close-on-click-outside="false"
    :width="1000"
  >
    <template v-slot:body>
      <div class="flex flex_between md-group">
        <md-button
          class="flex_1"
          :class="{ 'md-primary': activeType === activeTypes.process }"
          @click="changeActiveType(activeTypes.process)"
        >
          {{ $t("trackPay.contractsEditModal.contractAddProcess") }}
        </md-button>
        <md-button
          class="flex_1"
          :class="{ 'md-primary': activeType === activeTypes.salesContract }"
          @click="changeActiveType(activeTypes.salesContract)"
        >
          {{ $t("common.payments") }}
        </md-button>
      </div>
      <Process
        v-show="activeType === activeTypes.process"
        :contract-data="contractData"
        ref="Process"
        :isDebtor="true"
        @back="changeActiveType(activeTypes.trackers)"
        @relation-changed="debtorSupplierRelationChanged"
        @submit-relation="confirmSubmitRelation"
        @review-relation="confirmSubmitRelationToReview"
        @close="show(false)"
        :readOnly="readOnly"
        @next="changeActiveType(activeTypes.salesContract)"
        @save="save"
      ></Process>
      <DebtorPaymentDetail
        v-show="activeType === activeTypes.salesContract"
        :contract-data="contractData"
        :readOnly="readOnly"
        ref="DebtorPaymentDetail"
        @back="changeActiveType(activeTypes.process)"
        @close="show(false)"
        @reject="save('reject')"
        @confirm="save('confirm')"
        @success="success"
      ></DebtorPaymentDetail>
    </template>
  </Modal>
</template>

<script>
import Modal from "src/components/templates/modal/Modal";
import {debtorManagementApi} from "src/common/api/debtorManagementApi";
import DebtorPaymentDetail from "@/components/templates/trackPay/debtor/DebtorPaymentDetail";
import Process from "@/components/templates/trackPay/Process";
import {enumDef} from "@/common/enumDefs";
import {trackPayApi} from "../../../../common/api/trackPayApi";

const { trackPayStats } = enumDef;

export default {
  components: {
    Modal,
    DebtorPaymentDetail,
    Process,
  },
  data() {
    let activeTypes = {
      shipment: "delivery",
      salesContract: "salesContract",
      trackers: "trackers",
      process: "process",
    };

    return {
      editMode: false,
      shown: false,
      activeTypes: activeTypes,
      activeType: activeTypes.shipment,
      contractData: null,
      modalType: "add",
      readOnly: false,
    };
  },
  computed: {
    titleText() {
      let title = this.$t("trackPay.contracts.viewDetail");
      if (this.modalType === "edit") {
        title = this.$t("trackPay.contracts.editNewContract");
      }
      if (this.modalType === "viewDetail") {
        title = this.$t("trackPay.contracts.viewDetail");
      }
      return title;
    },
  },
  methods: {
    success() {
      this.show(false);
      this.$emit("success");
    },
    save(type) {
      let option = { ...this.contractData };
      if (type === "reject") {
        option.status = trackPayStats.Rejected;
      }
      else if (type === "confirm") {
        option.status = trackPayStats.Confirmed;
      }
      trackPayApi.debtor.changeStatus({id: option.id, status: option.status}).then(() => {
        this.show(false);
        this.$emit("success");
      });
    },
    show(value) {
      this.shown = value;
    },
    showRelationModal() {
      this.show(true);
      this.editMode = false;
      this.modalType = "add";
      this.readOnly = false;
      this.activeType = this.activeTypes.process;
      this.contractData = {};
    },
    showDetail(data) {
      trackPayApi.debtor.getContract(data.data.id).then((res) => {
        this.show(true);
        this.editMode = data.btnType;
        this.modalType = data.btnType;
        this.contractData = res;
        this.activeType = this.activeTypes.process;
        this.readOnly = false;

        if (this.modalType === "viewDetail") {
          this.readOnly = true;
        } else {
          this.activeType = this.activeTypes.salesContract;
        }
        this.$nextTick(() => {
          if (this.$refs.ShipmentForm) {
            this.$refs.ShipmentForm.form = {
              ...this.$refs.ShipmentForm.form,
              ...this.contractData,
            };
          }
          this.$refs.DebtorPaymentDetail.form = {
            ...this.$refs.DebtorPaymentDetail.form,
            ...this.contractData,
          };
          if (this.$refs.TrackersForm) {
            this.$refs.TrackersForm.form = {
              ...this.$refs.TrackersForm.form,
              ...this.contractData,
            };
          }
        });
      })
    },
    changeActiveType(type) {
      this.activeType = type;
    },
    confirmSubmitRelation() {
      let option = {
        title: this.$t("debtorManagement.addDebtor.confirm.title"),
        msg: this.$t("debtorManagement.addDebtor.confirm.text"),
        confirmFun: this.submitRelation,
      };
      this.confirmMeg(option, true);
    },
    submitRelation() {
      debtorManagementApi.operation
        .addBusinessRelation(this.buildRelationData())
        .then(() => {
          this.toastSuccess();
          this.debtorSupplierRelationChanged();
        })
        .catch(this.toast);
    },
    confirmSubmitRelationToReview() {
      let option = {
        title: this.$t("debtorManagement.reviewDebtor.confirm.title"),
        msg: this.$t("debtorManagement.reviewDebtor.confirm.text"),
        confirmFun: this.submitRelationToReview,
      };
      this.confirmMeg(option, true);
    },
    submitRelationToReview() {
      debtorManagementApi.operation
        .submitBusinessRelation(this.buildRelationData())
        .then(() => {
          this.toastSuccess();
          this.debtorSupplierRelationChanged();
        })
        .catch(this.toast);
    },
    debtorSupplierRelationChanged() {
      this.show(false);
      this.$emit("change");
    },
    buildRelationData() {
      let delivery = {
        ...this.$refs.delivery.getData(),
      };

      return {
        id: this.contractData ? this.contractData.id : null,
        debtor: delivery,
        contacts: this.$refs.payments.getData(),
        credits: this.$refs.trackers.getData(),
        documents: this.$refs.contractAddprocess.getData(),
      };
    },
  },
};
</script>
